// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"293":"component---src-pages-index-js","670":"component---src-pages-work-js"}[chunkId] + "-" + {"293":"c0b4618e40cfe253bc4b","670":"337921b1641127a0c52d"}[chunkId] + ".js";
};